import { object, string } from "yup";

export const signInSchema = object({
  email: string().email().required(),
  password: string().min(6).max(64).required(),
});
